import type { FieldErrors, FieldValues } from 'react-hook-form';

function countFieldErrors(error: unknown): number {
  if (!error || typeof error !== 'object') return 0;
  const record = error as Record<string, unknown>;
  const isFieldError = typeof record['type'] === 'string';
  let count = isFieldError ? 1 : 0;
  for (const [key, child] of Object.entries(record)) {
    if (isFieldError && ['type', 'message', 'types', 'ref'].includes(key)) continue;
    count += countFieldErrors(child);
  }
  return count;
}

/** Unmapped fields belong to the default section; global form errors belong to no tab. */
export function getFormTabErrorCounts<TValues extends FieldValues>(
  errors: FieldErrors<TValues>,
  fieldsByTab: Partial<Record<string, readonly (keyof TValues)[]>>,
  defaultTab?: string,
): Partial<Record<string, number>> {
  const counts: Partial<Record<string, number>> = {};
  const tabs = Object.keys(fieldsByTab);
  for (const [field, error] of Object.entries(errors)) {
    if (field === 'root') continue;
    const tab = tabs.find((tab) => fieldsByTab[tab]?.includes(field)) ?? defaultTab;
    if (tab !== undefined) counts[tab] = (counts[tab] ?? 0) + countFieldErrors(error);
  }
  return counts;
}
